import React from 'react'
import { StyleSheet, css } from 'aphrodite'

// MATERIAL
import Hidden from '@material-ui/core/Hidden'
import Instafeed from 'react-instafeed';

// EXTRA COMPONENTS
import SkewBg from './SkewBg'
// import CardAchievement from './Cards/CardAchievement'

// IMAGES
import Ipad from '../../../assets/instaFeed/ipad.png'

export default class InstaFeed extends React.Component{
    render(){
    const instafeedTarget = 'instafeed';
    return(
      <Hidden mdDown>
        <section className={css(styles.MainContainer)}>
            <SkewBg />
            <div className="container">
                <section className={css(styles.SecondaryContainer)}>
                        <div style={{backgroundImage: `url('${Ipad}')`}} className={css(styles.ipadFeed)}>
                            <div className={css(styles.InsideIpad)} id={instafeedTarget}>
                              <Instafeed
                                limit='6'
                                ref='instafeed'
                                resolution='standard_resolution'
                                sortBy='most-recent'
                                target={instafeedTarget}
                                template=
                                    "<a href='{{link}}' target='_blank'>
                                      <div class='instafeed-img'
                                      style='margin: 0em; 
                                      position:relative;
                                      border-top: 20px solid white;
                                      border-bottom: 0px solid white;
                                      border-left: 20px solid white;
                                      border-right: 0px solid white;
                                      width: 292px;
                                      height:274.5px;
                                      background-image: url({{image}});
                                      background-color: white;
                                      background-size: cover;
                                      flex-grow: 1;
                                      flex-shrink: 0;
                                      flex-basis: calc(25% - 10px);
                                     '>
                                         <span class='instafeed__item__caption'>
                                      {{model.short_caption}}
                                      </span>
                                      </div>
                                    </a>"
                                userId="7227559517"
                                accessToken="7227559517.1677ed0.3d5fab9713814488b7eeca1dff7a15f1"
                              />
                            </div>
                        </div>
                </section>
            </div>
        </section>
        </Hidden>
    )
  }
}

const styles = StyleSheet.create({
    MainContainer: {
        position: 'relative',
        minHeight: 800,
    },
    SecondaryContainer: {
        paddingTop: '5%',
        color: 'white',
        lineHeight: '1.8em',
        textAlign: 'center'
    },
       ipadFeed: {
        width: 1080,
        height: '800px',
        margin: '0 auto',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        zIndex: 100,
        filter: 'drop-shadow(0px 2px 6px rgba(0,21,64,.14)) drop-shadow(0 10px 20px rgba(0,21,64,.14))'
        },
        InsideIpad: {
            height: 753,
            padding: '161px 33px 43px 95px',
            display: 'flex',
            flexGrow: 1,
            flexWrap: 'wrap'
        }
});


// WEBPACK FOOTER //
// ./src/Components/Home/InstaFeed/InstaFeed.js